// Reusable TextField styles for Radix UI components

export const inputBottomBorder = {
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: '1px solid #B9C1D933',
  borderRadius: '0',
  background: 'transparent',
  paddingLeft: '0',
  paddingRight: '0',
  boxShadow: 'none'
} as const
